/**
 * Shares a pending panel snapshot request without caching the response itself.
 * Callers keep ownership of their own response cache and authorization context.
 */
export const createPanelSnapshotRequestRegistry = () => {
  const pendingRequests = new Map()

  const run = (key, requestFactory) => {
    if (pendingRequests.has(key)) return pendingRequests.get(key)

    let request

    try {
      request = Promise.resolve(requestFactory())
    } catch (error) {
      request = Promise.reject(error)
    }

    pendingRequests.set(key, request)

    // Remove successful and failed requests so the next refresh can retry.
    request.then(
      () => pendingRequests.delete(key),
      () => pendingRequests.delete(key),
    )

    return request
  }

  return { run }
}
